module.exports = __webpack_public_path__ + "static/img/lora.bc32cf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lora.jpg
// module id = 248
// module chunks = 1